export type WalkInStatus = 'active' | 'finished' | 'autoResolved';

export const INACTIVE_WALK_IN_STATUSES: WalkInStatus[] = [
  'finished',
  'autoResolved',
];
